import { gql, graphql } from "react-apollo"

const SEND_TEXT_NOTIFICATION = gql`
  mutation sendTextNotification($phoneNumber: String!) {
    sendTextNotification(phoneNumber: $phoneNumber) {
      messageId
      sentAt
    }
  }
`

const mutateSendTextNotification = graphql(SEND_TEXT_NOTIFICATION, {
  name: "mutateSendTextNotification",
  props: ({ mutateSendTextNotification }) => ({
    sendTextNotification: ({ phoneNumber }: { phoneNumber: string }) =>
      mutateSendTextNotification({
        variables: { phoneNumber }
      })
  })
})

export default mutateSendTextNotification



// WEBPACK FOOTER //
// ./src/Kiosk/queries/mutateSendTextNotification.js